var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1567,
    viewBox: "0 0 1920 1567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1567,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3107_288906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1567
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1567,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3107_288906)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.390555,
    filter: "url(#filter0_f_3107_288906)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1757.5,
    cy: 1843.5,
    rx: 657.5,
    ry: 523.5,
    fill: "url(#paint0_radial_3107_288906)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.296526,
    filter: "url(#filter1_f_3107_288906)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -99.5,
    cy: 311,
    rx: 657.5,
    ry: 447,
    fill: "url(#paint1_radial_3107_288906)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3107_288906",
    x: 964.086,
    y: 1184.09,
    width: 1586.83,
    height: 1318.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.957,
    result: "effect1_foregroundBlur_3107_288906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3107_288906",
    x: -892.914,
    y: -271.914,
    width: 1586.83,
    height: 1165.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.957,
    result: "effect1_foregroundBlur_3107_288906"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3107_288906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1571.27 1773.73) rotate(90) scale(1047 1315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5F6FF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083055,
    stopColor: "#C5F6FF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3107_288906",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.321 179.862) rotate(95.1793) scale(949.235 1390.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC36B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984226,
    stopColor: "#FFFEFD",
    stopOpacity: 0.0157744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.72b1c5b7bceaed0b6eadb4f998fb3312.svg";
export { ForwardRef as ReactComponent };